var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmap-marker',{attrs:{"position":_vm.position,"animation":_vm.animation,"icon":_vm.icon,"draggable":true},on:{"dragend":function($event){return _vm.updatePosition($event.latLng)},"click":_vm.toggleBounce}})}
var staticRenderFns = []

export { render, staticRenderFns }